export { default } from './UpdatedEvent';
